<template>
  <sidebar-layout>
    <template #top>
      <status-banner :text="successText" icon="icon-ok" status="success">
        <not-me-link v-if="alreadySignedOnPageLoad" :user-name="actionTakerName" context="already_signed" />
      </status-banner>
    </template>

    <template v-if="petition.successful">
      <success-banner />
      <hr class="my-4">
    </template>

    <progress-and-recent-signatures />

    <sharing-prompt v-if="petition.sharingAllowed" :title="i18n.t('petitions.signatures.increase_your_impact')" />
    <comment-form v-if="createPetitionCommentPath" class="mt-3" :create-petition-comment-path="createPetitionCommentPath" />
  </sidebar-layout>
</template>

<script>
import CommentForm from '../comments/form'
import { mapState } from 'vuex'
import NotMeLink from './not-me-link.vue'
import ProgressAndRecentSignatures from './progress-and-recent-signatures'
import SharingPrompt from '@/campaign-action-shared/sharing-prompt'
import SidebarLayout from '@/campaign-action-shared/sidebar-layout'
import StatusBanner from '@/campaign-action-shared/status-banner'
import SuccessBanner from './success-banner'

export default {
  components: { CommentForm, NotMeLink, ProgressAndRecentSignatures, SharingPrompt, StatusBanner, SidebarLayout,
                SuccessBanner },

  computed: {
    ...mapState(['actionTakerName', 'alreadySignedOnPageLoad', 'createPetitionCommentPath', 'petition']),

    successText() {
      if (this.petition.signersWriteToDecisionMaker) {
        return this.i18n.t('petitions.signatures.create.message_sent')
      } else {
        return this.i18n.t('petitions.signatures.already_signed.already_signed')
      }
    }
  }
}
</script>
